import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { request, deleteThis } from '../../redux/actions/genericAction';
import ActivityReportComp from '../reportsPage/reportTypes/ActivityReportComp';
import HotSpotReportComp from '../reportsPage/reportTypes/HotSpotReportComp';
import SkillsReportComp from '../reportsPage/reportTypes/SkillsReportComp';
import UnitReportComp from '../reportsPage/reportTypes/UnitReportComp';
import PretestReportComp from '../reportsPage/reportTypes/PretestReportComp';
import PostTestReportComp from '../reportsPage/reportTypes/PostTestGraphComp';
import ClassReportComp from '../reportsPage/reportTypes/ClassReportComp';
import axios from 'axios';
import { convertDictionaryKeys, isObjectEmpty, toArray, arrayToObject } from '../../Utils';
import { resourceDomain, setupDatabase } from '../../ApiHelper';

import MasteredFactsComp from '../reportsPage/reportTypes/madMinute/MasteredFactsComp';
import ReportByDayComp from '../reportsPage/reportTypes/madMinute/ReportByDayComp';
import PretestComp from '../reportsPage/reportTypes/madMinute/PretestComp';
import ReportByMonthComp from '../reportsPage/reportTypes/madMinute/ReportbyMonthComp';
import CumulativeReportComp from '../reportsPage/reportTypes/madMinute/CumulativeReportComp';
import Last30DayReportComp from '../reportsPage/reportTypes/madMinute/Last30DayReportComp';

import UserBuilderMarksReportComp from './reportTypes/UserBuilder/MarkReportComp';
import LessonBuilderAnswerReportComp from './reportTypes/UserBuilder/AnswerReportComp';
import LessonBuilderStandardReportComp from './reportTypes/UserBuilder/StandardReportComp';
import LessonBuilderLessonsReportComp from './reportTypes/UserBuilder/LessonReportComp';

import LessonBuilderCourseReportComp from './reportTypes/UserBuilder/CourseMarkReportComp';
import LessonBuilderCourseAnswerReportComp from './reportTypes/UserBuilder/CourseAnswerReportComp';
import LessonBuilderSLEAnswerReportComp from './reportTypes/UserBuilder/SLEAnswerReportComp';

const ViewReportsPage = ({database, request, deleteThis, programs, csvData, setcsvData, loadingLessonCount, setLoadingLessonCount}) => {
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState({});
  const [isFetchingModules, setIsFetchingModules] = useState(false);
  const [modulesReady, setModulesReady] = useState(false);
  const [modulesData, setModulesData] = useState([]);
  const [processedProgramSummary, setProcessedProgramSummary] = useState([]);
  const [reportType, setReportType] = useState([]);

  const reloadCSVFile = () =>{
    if(csvData){
      setReportType(csvData.reportType);
      setSelectedProgram({...csvData.selectedProgram});
      setSelectedStudents([...csvData.selectedStudents]);
    }
  };

  useEffect(()=>{
    reloadCSVFile();
  },[csvData]);


  // useEffect(()=>{
  //   reloadCSVFile();
  // },[database['getProgramMarks']]);

  // useEffect(()=>{
  //   reloadCSVFile();
  // },[database['getPretestModuleMarks']]);
  
  // useEffect(()=>{
  //   reloadCSVFile();
  // },[database['getMadMinuteMarks']]);

  // useEffect(()=>{
  //   reloadCSVFile();
  // },[database['getMadMinuteFacts']]);

  useEffect(() => {
        
    if(selectedStudents.length !== 0 ) return; // already loading

    if(!database['getCustomer']){
        let reportData = JSON.parse(localStorage.getItem('reportData'));
        sessionStorage.setItem('token',reportData.token);
        setReportType(reportData.reportType);
        setSelectedProgram(reportData.selectedProgram);
        setSelectedStudents(reportData.selectedStudents);
    }
  }); 

  const fetchModules = async (progID) => {
    if(!progID) return;

    setIsFetchingModules (true);
    setModulesData([]);
    setModulesReady(false);

    let program = programs[progID.toUpperCase()];
    let modules = [];
    let numModules = program.modules.length;
    let moduleIDs = program.modules.map(mod=>mod[0]);

    await program.modules.map(async (moduleRec,i) => {
        if(moduleRec[0].toLowerCase()==='placeholder') return;
        
        let response = await axios.get(`${resourceDomain}programs/${progID.toLowerCase()}/data/progstruct/${moduleRec[0].toLowerCase()}.json`);

        let flattedLinks = [];
        let flattedLinksTest = {};
        let flattedUnits = [];
        let flattedUnitsTest = {};

        function flattenTree (moduleID, links, unit){
          if(!links) return; 

          links.forEach(link=>{
            unit = (unit)?unit:{}; 
            (link.isActivity==='true' && unit.actIDs) && unit.actIDs.push(link.id);

            // if the activity itself is a unit
            if(link.isActivity==='true' && link.isUnit==='true'){
              let subActivities = {name:link.name, moduleID, linkID:link.id, actIDs:[link.id]};
              // dont allow duplicates
              if(!flattedUnitsTest[moduleID[0]+link.id]){
                flattedUnits.push(subActivities);
                flattedUnitsTest[moduleID[0]+link.id] = subActivities;
              }
            }
            
            let rec = {moduleID, 
              linkID: link.id, 
              name: link.name,
              unit, 
              isActivity: (link.isActivity==='true'),
              isMenu: (link.isMenu==='true'),
              isUnit: (link.isUnit==='true'),
            };

            // dont allow duplicates
            if(!flattedLinksTest[moduleID[0]+link.id]){
              flattedLinks.push(rec);
              flattedLinksTest[moduleID[0]+link.id] = rec;
            }

            if(link.links && link.links.length > 0){
              if(link.isUnit==='true'){
                if(isObjectEmpty(unit) || !(unit.actIDs)){ // units inside units not allowed
                  unit = {name:link.name, moduleID, linkID:link.id};
                  let subActivities = {name:link.name, moduleID, linkID:link.id, actIDs:[]};
                  flattenTree(moduleID, link.links, subActivities);
                  // don't allow duplicates
                  if(!flattedUnitsTest[moduleID[0]+link.id]){
                    flattedUnits.push(subActivities);
                    flattedUnitsTest[moduleID[0]+link.id] = subActivities;
                  }
                }
                else{ // allow to get unit names
                  unit = {name:link.name, moduleID, linkID:link.id};
                }
              }
              flattenTree(moduleID, link.links, unit);
            }
          });
        }

        if(response.data.isUnit==='true'){ // the entire module is a single unit
          let subActivities = {name:response.data.name, moduleID:moduleRec[0], linkID:response.data.id, actIDs:[]};
          flattenTree(moduleRec[0], response.data.links, subActivities);
          flattedUnits.push(subActivities);
        }
        else{
          flattenTree(moduleRec[0], response.data.links);
        }
        modules.push({moduleID: moduleRec, links: flattedLinks, units: flattedUnits});

        if(program.modules.length === modules.length){

          modules = modules.sort(function(a, b){
            return moduleIDs.indexOf(a.moduleID[0])
                  - moduleIDs.indexOf(b.moduleID[0]);
          });

          setModulesReady(true);
          setIsFetchingModules (false);
          setModulesData([...modules]);            
        }
      }
    );    
  };  

  const NODEAPI = 'http://contentcreator.essentialskills.com:3000/api/';  
  const LIVEAPI = 'http://sle.essentialskills.com/code/database.php';
  // const V7NODEAPI = 'http://v7nodeapi.essentialskills.com:1337/api/query';
  // const V7PHPAPI = 'http://v7phpapi.essentialskills.com/aws.php';
  // const V7LAMBDAAPI= 'https://m09jf6n9m1.execute-api.us-east-1.amazonaws.com/default/v7rest';
  const POLYAPI = 'https://21h24udi71.execute-api.us-east-1.amazonaws.com/default/polly';
  // const OLD_LAMBDA = 'https://m7a9wcdv0d.execute-api.us-east-1.amazonaws.com/dev';

  const reportState ={
    selectedStudents, setSelectedStudents,
    selectedProgram, setSelectedProgram,
    V7DATABASE: setupDatabase(sessionStorage.getItem('productionPath'))
  };

  const pageState ={
    isFetchingModules, setIsFetchingModules,
    processedProgramSummary, setProcessedProgramSummary,
    modulesReady, setModulesReady,
    modulesData, setModulesData,
    database, request, deleteThis, fetchModules, programs
  };

  return (
    <div>
      {(reportType === 'Activity') && <ActivityReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'HotSpot') && <HotSpotReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'Unit') && <UnitReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'Skills') && <SkillsReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'Pretest') && <PretestReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'Posttest') && <PostTestReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>} 
      {(reportType === 'Class') && <ClassReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}

      {(reportType === 'MMMasteredFacts') && <MasteredFactsComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'MMPretests') && <PretestComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'MMDay') && <ReportByDayComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'MMMonth') && <ReportByMonthComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'MMStatus') && <CumulativeReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'MMStatusMonth') && <Last30DayReportComp reportState={reportState} pageState={pageState} csvData={csvData} setcsvData={setcsvData}/>}

      {(reportType === 'LessonMarks') && <UserBuilderMarksReportComp reportState={reportState} pageState={pageState} loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}      
      {(reportType === 'LessonLessons') && <LessonBuilderLessonsReportComp reportState={reportState} pageState={pageState} loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}      
      {(reportType === 'LessonStandards') && <LessonBuilderStandardReportComp reportState={reportState} pageState={pageState} loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}      
      {(reportType === 'LessonAnswers') && <LessonBuilderAnswerReportComp reportState={reportState} pageState={pageState} loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}      

      {(reportType === 'CourseMarks') && <LessonBuilderCourseReportComp reportState={reportState} pageState={pageState} loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}
      {(reportType === 'CourseAnswers') && <LessonBuilderSLEAnswerReportComp reportState={reportState} pageState={pageState} loadingLessonCount={loadingLessonCount} setLoadingLessonCount={setLoadingLessonCount} csvData={csvData} setcsvData={setcsvData}/>}      
    </div>
  );
};

const mapStateToProps = state => {
  return {
      isAdmin: (state.dashboardReducer.login === 'Admin'),
      database: state.genericReducer,
      programs: convertDictionaryKeys(state.rawProgramReducer.programs, 'id') 
  };
};

export default connect(mapStateToProps, { request, deleteThis })(ViewReportsPage);